import { types } from "mobx-state-tree";

import { createCustomReadonlyDictionary } from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";
import { MSURL } from "utils/ms";

const corePath = "/core/api/v1";
export const TargetZoneDictionaryItem = types.model({
  id: types.number,
  title: types.string,
});

const TargetZoneDictionary = createCustomReadonlyDictionary({
  itemModel: TargetZoneDictionaryItem,
  fetch: async function() {
    const response = await api.get(
      `${corePath}/target-zone/slim`,
      undefined,
      undefined,
      MSURL,
    );
    return { items: response };
  },
  getValue: value => value,
  getLabel: ({ title }) => title,
});

export default TargetZoneDictionary.create();
